import { ClaimService } from "src/services";
import { useFileDownload } from "../useFileDownload";

export const useClaimFileDownload = (claimService: ClaimService) => {
  const {
    mutate: download,
    isPending: isFileDownloading,
    error: fileLoadError,
    retry: retryDownload,
    reset: resetDownload
  } = useFileDownload<File | File[]>();

  const downloadClaimCreditFiles = (claimId: string) => {
    download({
      getFileData: () => claimService.getClaimCreditFiles(claimId),
      zipName: `${claimId}-credit-files`
    });
  };

  return {
    downloadCreditFiles: downloadClaimCreditFiles,
    isFileDownloading,
    fileLoadError,
    retryDownload,
    resetDownload
  };
};
